import React from 'react';
import './assets/styles/App.css';
import { lightTheme } from './assets/styles/theme';
import FastContact from './components/FastContact';
import Footer from './components/Footer';
import Header from './components/Header';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { Container } from '@mui/material';
import Services from './components/Services';
import AboutUs from './components/AboutUs';
import Cover from './components/Cover';
import ContactUs from './components/ContactUs';

function App() {
  const theme = lightTheme;
  // https://mui.com/material-ui/customization/dark-mode/
  return (
    <>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Header/>
      <FastContact/>
      <Cover/>
      <Container component="main" sx={{ maxWidth: { xl: 1360 } }}>
        <AboutUs/>
        <Services/>
      </Container>
      <ContactUs/>
      <Footer/>
    </ThemeProvider>
    </>
  );
}

export default App;
